module.exports = __webpack_public_path__ + "img/sort_desc.09aa4092.svg";